@import 'src/styles/common/_colors.scss';
.suggestionBody {
    background-color: $gray-variant;
    overflow-y: scroll;
    .suggestionlist,
    >ul {
        list-style-type: disc;
        width: 100%;
        padding: 0;
        flex: 1;
        overflow-x: hidden;
        >li {
            display: flex;
            width: 100%;
            align-items: center;
        }
    }
}

.suggestionContent {
    margin-left: 0.5rem;
}

.suggestionbCloseButtom {
    font-size: 12px;
}

.namePargraph {
    margin-bottom: 0.375rem;
}
.subCausesListStyle{
    margin:0.375rem 0;
    line-height: normal;
}
.nameHeading {
    margin-bottom:0.375rem;
}
.suggestionFooter {
    position:relative !important;
}

.suggestionDescription {
    line-height: 20px;
    margin-bottom: 0.5rem;
}
.suggestionNotes {
    line-height: 10px;
}

.noCauses {
    text-align: center;
    width: 100%;
    margin-top: 10px;
}

.loadingContent{
    min-width: 300px;
    min-height: 150px;
}

.customModalContent {
	position: absolute !important;
	animation-name: filterAnimation;
	animation-duration: 0.3s;
	animation-fill-mode: forwards;
}

@keyframes filterAnimation {
	from {
		top: -25%;
	}
	to {
		top: 40px;
	}
}